module.exports = __webpack_public_path__ + "static/media/login.0c3ca632.jpeg";